export default __webpack_public_path__ + "static/media/IMG_20190721_095743.cf6d3382.jpg";